(function () {
    'use strict';

    var serviceId = 'provinceListService';

    angular.module('app.common')
        .factory(serviceId, ['geoApi', provinceListService]);

    function provinceListService(geoApi) {

        var obj = {
            getProvinces: getProvinces,
            CountiesOfProvince: CountiesOfProvince,
            NeighbourhoodsOfCounty: NeighbourhoodsOfCounty,
            NeighbourhoodsOfQuarter: NeighbourhoodsOfQuarter
        };
        return obj;
        function getProvinces(id) {
            var geoAp = geoApi.getListById({
                level: 9,
                countryId: id
            });
            return geoAp.$promise;
        }

        function CountiesOfProvince(country, id) {
            var geoAp = geoApi.getListById({
                level: 1,
                cityId: id,
                countryId: country
            });
            return geoAp.$promise;
        }

        function NeighbourhoodsOfCounty(country, city, county) {
            var geoAp = geoApi.getListById({
                level: 2,
                cityId: city,
                countyId: county,
                countryId: country
            });
            return geoAp.$promise;
        }

        // Get neighbourhoods for Spain based on quarter - level 23
        function NeighbourhoodsOfQuarter(country, city, county, quarterId) {
            var geoAp = geoApi.getListById({
                level: 23,
                cityId: city,
                countyId: county,
                quarterId: quarterId,
                countryId: country
            });
            return geoAp.$promise;
        }


    }
})();
